import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { UserStore } from '../../../store/user/user.store';
import { providerRouter } from './helper/provider-router.helper';
import { ProviderStore } from '../../../store/provider/provider.store';

export const onboardingCompleteMatchGuard: CanMatchFn = async (route, segments) => {
  const userStore = inject(UserStore);
  const providerStore = inject(ProviderStore);
  const router = inject(Router);

  try {
    await providerStore.getAllProvidersByClinic();
    const providers = providerStore.entities();
    const isUserActive = userStore.active();

    // SUCCESS CONDITION: Everyone must be 5 or higher
    const everyoneComplete = providers.length > 0 && providers.every(p => p.onboarding_status >= 5);

    if (everyoneComplete && !isUserActive) {
      return true;
    }

    // If even one provider is still at 4, redirect to documents.
    // If your providerRouter(4) returns the documents path, this fixes the loop.
    const currentStatus = everyoneComplete ? userStore.onboarding_status() : 4;
    return router.createUrlTree([providerRouter(currentStatus)]);
    
  } catch (error) {
    return router.createUrlTree(['/login']);
  }
};
